import loadjs from "load-script";

export default defineNuxtPlugin(() => {
  const env = process.env.CODE_ENV || process.env.NODE_ENV;
  // 排除生产环境和海外SPG环境，不加载 vconsole
  // const urlParams = new URLSearchParams(window.location.search);
  // urlParams.get('vconsole') === '1'
  if (env !== "production" && env !== "spg") {
    loadjs("//lib.baomitu.com/vConsole/3.10.0/vconsole.min.js", function (err) {
      if (err) {
        // print useful message
      } else {
        // eslint-disable-next-line no-new,no-undef
        new VConsole();
      }
    });
  }
});
